import { Component, OnInit } from '@angular/core';
import { Meta, MetaDefinition, Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';


import { HrefLang, HrefLangDefinition } from '../shared/hreflang.service';
import { AppSettings } from '../settings/app.settings';
import { SEOService } from '../shared/seo-service';

@Component({
  selector: 'cookie',
  templateUrl: './cookie.component.html',
  styleUrls: ['./cookie.component.scss']
})
export class CookieComponent implements OnInit{
  public contactUrl:string;
  public termsUrl:string;
  constructor(private title:Title,
    private translate:TranslateService, private meta:Meta, private hlang:HrefLang, private seoService:SEOService){ };

  ngOnInit(){

    this.transformUrl('CONTACT_URL').subscribe(path => {
        this.contactUrl = `/${this.translate.getDefaultLang()}/${path}`;
      });

    this.transformUrl('TERMS_OF_USE_URL').subscribe(path => {
        this.termsUrl = `/${this.translate.getDefaultLang()}/${path}`;
      });

      this.translate.get("META_TITLE_PRIVACY").subscribe(text=>{
          this.title.setTitle(text);
      });
      this.translate.get("META_DESC_PRIVACY").subscribe(text=>{
          let tag:MetaDefinition = {
              name:"description",
              content:text
          };
          this.meta.addTags([tag]);
      });
       let langs = [
          {lang:'es',text:'politica-privacidad-cookies'},
          {lang:'en',text:'privacy-cookies-policy'}/*,
          {lang:'fr',text:'politique-confidentialite-et-cookies'},
          {lang:'it',text:'informativa-privacy-e-cookies'},
          {lang:'de',text:'datenschutzbestimmungen-zur-verwendung-von-cookies'}
        */];
        langs.forEach(lang => {
          let hreflang_:HrefLangDefinition = {
              rel: "alternate",
              href: `${AppSettings.BASE_DOMAIN}/${lang.lang}/${lang.text}`,
              hreflang: `${lang.lang}`
          }
          this.hlang.addTags([hreflang_]);
        });

        this.seoService.createLinkForCanonicalURL('');
  }

  transformUrl(urlToTranslate){
   return this.translate.get(urlToTranslate);
  }
}